<template>
  <r-datetextpicker
    :value="value"
    :hide-details="hideDetails"
    :disabled="disabled"
    :loading="loading"
    @input="updateSelected"
  />
</template>

<script>
import moment from 'moment'
import datetextpicker from '../customComponents/r-datetextpicker'

export default {
  components: {
    'r-datetextpicker': datetextpicker
  },
  props: [
    'value',
    'hideDetails',
    'disabled',
    'loading',
  ],
  data () {
    return {
      date: moment()
    }
  },
  computed: {
    was () {
      return this.value.format()
    },
    date_formatted () {
      return this.date.format('DDMMYYYY')
    }
  },
  watch: {
    value () {
      this.date = this.value
    }
  },
  methods: {
    updateSelected (data) {
      this.$emit('input', data)
    }
  }
}
</script>

<style lang="scss">

</style>
